<template>
    <table class="mb-3">
      <thead>
        <tr>
          <th v-for="(item, i) in headers" :key="i" :class="getColumnClass(item.field)">
            <template v-if="item.visible">
              {{ item.name }}
            </template>
          </th>
        </tr>
      </thead>
      <tbody v-if="props.items.length">
        <template v-for="(item, i) in props.items" :key="i">
          <tr>
            <td class="icon-column">
              <svg viewBox="0 0 384 512" height="1em">
                <path
                  d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z" />
              </svg>
            </td>
            <td>{{ item?.organisationNumber }}</td>
            <td>
              <router-link v-if="item?.status === 'Accepted'" :to="{ name: 'OrgDetailView', params: { orgId: item.id } }">
                {{ item?.displayName }}
              </router-link>
              <span v-else>{{ item?.displayName }}</span>
            </td>
            <td v-if="item?.status" class="status-column">{{ getStatusText(item?.status) }}</td>
          </tr>
        </template>
      </tbody>
      <tbody v-else class="ml-2">
        <tr >
          <td colspan="4" class="">Ingen organisation registrerad ännu...</td>
        </tr>
      </tbody>
    </table>
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import Symbol from "../components/Symbol.vue"
import { OrganisationModel } from "@Shared/Models/OrganisationModel";
import { getColumnClass } from "@/helper/getColumnClass";
import { TableHeader } from "@/static/types/TableHeader";

export default defineComponent({
  components: {
    Symbol
  },
  name: 'TableOrganisations',
  props: {
    type: {
      type: String,
      default: ""
    },
    items: {
      type: Array<OrganisationModel>,
      default: []
    }
  },

  setup(props) {
    const getStatusText = (status: 'Created' | 'Accepted' | 'Rejected' | ''): string => {
      switch(status) {
        case 'Created':
          return 'Inväntar granskning av SPSM'
        case 'Accepted':
          return 'Godkänd'
        case 'Rejected':
          return 'Avslagen'
        default:
          return ''
      }
    }


    const headers: TableHeader[] = [
      {field: 'icon', name: "Icon",visible: false },
      {field: 'organisationNumber', name: "Orgnummer",visible: true },
      {field: 'displayName', name: "Organisationsnamn",visible: true },
      {field: 'status', name: "Status", visible: true }
    ];

    return {
      props,
      headers,
      getColumnClass,
      getStatusText
    };
  }
})

</script>

<style lang="scss">
@import '../assets/table.scss';

</style>